/**
 * Draw worker makes a huge assumption:
 * Data that is sent for a layer will always be drawn because LAYER EXISTS
 */

let baseCanvas



export default () => {
	self.addEventListener('message', e => { // eslint-disable-line no-restricted-globals
    // var baseCanvas = null
    if (!e) return;
    
    switch(e.data.message_type){
      case "draw":
        // code block
        // var canvas = e.data.canvas
        var canvas = baseCanvas
        var ctx = canvas.getContext('2d') // get webgl context
        ctx.lineWidth = e.data.lw;
        ctx.lineCap = e.data.lcap;
        ctx.lineTo(e.data.x, e.data.y)
        ctx.stroke();
        break;
      
      case "start":
        if(e.data.canvas){
          baseCanvas = e.data.canvas
        }
        // console.log(baseCanvas) // voila! fucking works boiiiii
        var canvas = baseCanvas
        var ctx = canvas.getContext('2d') // get webgl context
        ctx.lineWidth = e.data.lw;
        ctx.lineCap = e.data.lcap;
        ctx.beginPath()
        ctx.moveTo(e.data.x, e.data.y)
        ctx.stroke()
        break

      case "commit":
        if(e.data.canvas){
          baseCanvas = e.data.canvas
        }
        // console.log(baseCanvas) // voila! fucking works boiiiii
        var canvas = baseCanvas
        var ctx = canvas.getContext('2d') // get webgl context
        var data = ctx.getImageData(0,0, e.data.w, e.data.h)
        var responseData = {
          "data" :data,
          "name":e.data.layer_name
        }
        postMessage(responseData)
        break
      
      case "undo":
        if(e.data.canvas){
          baseCanvas = e.data.canvas
        }
        // console.log(baseCanvas) // voila! fucking works boiiiii
        var canvas = baseCanvas
        var ctx = canvas.getContext('2d') // get webgl context
        ctx.putImageData(e.data.undo_data, 0, 0)
        break
      case "redo":
        if(e.data.canvas){
          baseCanvas = e.data.canvas
        }
        // console.log(baseCanvas) // voila! fucking works boiiiii
        var canvas = baseCanvas
        var ctx = canvas.getContext('2d') // get webgl context
        ctx.putImageData(e.data.redo_data, 0, 0)
        break
      
      case "stamp":
        if(e.data.canvas){
          baseCanvas = e.data.canvas
        }
        // console.log(baseCanvas) // voila! fucking works boiiiii
        var canvas = baseCanvas
        var ctx = canvas.getContext('2d') // get webgl context

        ctx.globalAlpha = e.data.opacity
        ctx.drawImage(e.data.stamp, 0 ,e.data.y_offset)
        break
      case "download":
          if(e.data.canvas){
            baseCanvas = e.data.canvas
          }
          // console.log(baseCanvas) // voila! fucking works boiiiii
          var canvas = baseCanvas
          var ctx = canvas.getContext('2d') // get webgl context
  
          canvas.convertToBlob().then(function(blob) {
            // console.log(blob);
            postMessage({"blob":blob, "fname":e.data.layer_name.replace(/ /g, '_')});
          });
          // return 
          break
      case "zoom_in":
          if(e.data.canvas){
            baseCanvas = e.data.canvas
          }
          // console.log(baseCanvas) // voila! fucking works boiiiii
          var canvas = baseCanvas

          var ch = canvas.height
          var cw = canvas.width
          console.log([cw, ch])
          var ctx = canvas.getContext('2d') // get webgl context
          const imgBlob = canvas.convertToBlob().then( r => {
              createImageBitmap(r, 
                0, 
                0,
                ch,
                cw).then( r2 => {
                  ctx.save()
                  ctx.clearRect(0, 0, cw, ch);
                  ctx.scale(e.data.scale, e.data.scale)
                  ctx.drawImage(r2, 0, 0);
                  ctx.restore()

                })
          })
          break
      default:
        // code block
        console.log('default statement')
    }

	})
}

